import type { Metadata } from 'next';
import type { SupportedLanguage } from '@/app/types';
import { isEnterpriseDistribution } from './distribution';

export const TWITTER_LINK = 'https://x.com/ViduAI_official';
export const FRONTEND_ORIGIN = process.env.NEXT_PUBLIC_ORIGIN ?? '';

/**
 * 工作区下允许被搜索引擎索引的创作工具页面白名单。
 * 用途：
 * - robots.ts 在 disallow `/create/` 的同时，对这些路径放出 Allow；
 * - sitemap 注册这些路径作为可索引入口。
 * 新增工具时同步维护此清单，并确认页面 metadata 已去掉 noindex。
 */
export const PUBLIC_CREATE_TOOL_PATHS = [
  '/create/ai-sound-effects',
  '/create/ai-avatar-generator',
  '/create/ai-video-cutter',
  '/create/character-generator',
  '/create/extension',
  '/create/face-swap',
  '/create/image-edit',
  '/create/lip-sync',
  '/create/motion-control',
  '/create/one-click-mv',
  '/create/one-click-video-production',
  '/create/style-transfer',
  '/create/text-to-speech',
  '/create/upscale-image',
  '/create/upscale-video',
  '/create/video-edit',
  '/create/video-remake',
  '/create/voice-clone',
] as const;

export const CHINA_META: Metadata = isEnterpriseDistribution
  ? {
      title: {
        template: 'AI Vid - %s',
        default: 'AI Vid',
      },
      metadataBase: new URL(FRONTEND_ORIGIN),
      keywords: 'AI视频, 文生视频, 图生视频, 参考生视频, 主体一致性, 视频生成',
      applicationName: 'AI Vid',
      icons: [{ url: '/favicon-neutral.svg' }],
      other: {
        'baidu-site-verification': 'codeva-1yeCn2NeoK',
      },
    }
  : {
      title: {
        template: 'Vidu AI - %s',
        default: 'Vidu AI',
      },
      metadataBase: new URL(FRONTEND_ORIGIN),
      keywords: '生数Vidu, Vidu模型, Vidu, AI视频, 文生视频, 图生视频, 参考生视频, 主体一致性, Vidu, Vidu AI, 视频生成',
      applicationName: 'Vidu AI',
      authors: [{ name: 'Beijing Shengshu Technology Co., Ltd.' }, { url: 'https://www.shengshu-ai.com' }],
      icons: [{ url: '/logo.svg' }],
      other: {
        'baidu-site-verification': 'codeva-1yeCn2NeoK',
      },
    };

export const GLOBAL_META: Metadata = {
  title: {
    template: '%s | Vidu AI',
    default: 'Vidu AI',
  },
  metadataBase: new URL(FRONTEND_ORIGIN),
  keywords:
    'AI Video, Text-to-Video, Image-to-Video, Character-to-Video, Video Consistency, Vidu, Vidu AI, Video Generation, Shengshu Vidu, Vidu Model, Vidu, Vidu AI',
  applicationName: 'Vidu AI',
  icons: [{ url: '/logo.svg' }],
  alternates: {
    canonical: '/',
    languages: {
      en: '/',
      zh: '/zh',
      ja: '/ja',
      ko: '/ko',
      de: '/de',
      fr: '/fr',
      es: '/es',
      pt: '/pt',
      ru: '/ru',
    } as Record<SupportedLanguage, string>,
  },
};
